import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICLUTFileService } from 'src/app/services/image-capture/ic-lut-file.service';
import { NotificationService } from 'src/app/shared/notification.service';
import { BaseComponent } from 'src/app/support/base.component';

export interface ICSyncDeviceComponentData {
  instrumentSerial: string;
}

export interface ICSyncDeviceComponentResult {
  lutFiles: string[];
}

@Component({
  selector: 'ic-sync-device',
  templateUrl: './ic-sync-device.component.html',
  styleUrls: ['./ic-sync-device.component.scss'],
  standalone: false,
})
export class ICSyncDeviceComponent extends BaseComponent {
  instrumentSerial: string = '';
  lutFiles: string[] = [];
  status?: boolean = undefined;
  constructor(
    private notificationService: NotificationService,
    private lutFileService: ICLUTFileService,
    public dialogRef: MatDialogRef<ICSyncDeviceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ICSyncDeviceComponentData,
  ) {
    super();
    this.instrumentSerial = data.instrumentSerial;
  }

  protected ngOnDestroyInternal(): void {}

  // Add a method to close the dialog
  closeDialog(): void {
    this.dialogRef.close(this.lutFiles);
  }

  validateLUT(): void {
    this.subscription.add(
      this.lutFileService.getLUTFiles().subscribe(
        (response: string[]) => {
          this.lutFiles = response;
          this.status = this.lutFiles && this.lutFiles.includes(this.instrumentSerial);
        },
        () => {
          this.notificationService.error('Error fetching LUT files. Please try again later.');
        },
      ),
    );
  }
}
